import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { MatSpinnerOverlayService } from './../services/mat-spinner-overlay.service';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class InterceptorService implements HttpInterceptor {
  constructor(private matSpinnerOverlay: MatSpinnerOverlayService, private router: Router) { }

  handleError(error: HttpErrorResponse): Observable<never> {
    this.matSpinnerOverlay.hide();
    console.log('interceptor', error);
    return throwError(error);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // return next.handle(req).pipe(catchError(this.handleError));

    return next.handle(req).pipe(tap(() => { },
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status !== 401) {
            return;
          }

          this.router.navigate(['../audits']);
        }
      }));
  }
}
